/** Splits on newlines/commas/semicolons, trims, drops blanks and duplicates. */
export function parseEmails(text: string): string[] {
  const seen = new Set<string>();
  for (const part of text.split(/[\n,;]+/)) {
    const email = part.trim();
    if (email) seen.add(email);
  }
  return [...seen];
}

export function findInvalidEmails(emails: string[]): string[] {
  return emails.filter((e) => !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e));
}
